import { BusinessUnit, BusinessUnitGroup, getBusinessUnitGroup } from './businessUnitGroup';

/**
 * A Product Market is a higher level grouping than a BusinessUnitGroup. In Phoenix, for example, EF Study Abroad (CST) is rolled
 * up into the ETUS Product Market
 */
enum ProductMarket {
  EFTours = 'ETUS',
  ExploreAmerica = 'EAUS',
  EFToursCanada = 'ETCA',
}

/**
 * Product Market is yet another grouping that exists in Phoenix and some applications need it instead of a BusinessUnitGroup
 *
 * @param key - a business unit or string value of a BUG
 * @returns Matched Product Market Code, otherwise `throw`s
 */
const getProductMarket = (key: string | BusinessUnit | BusinessUnitGroup) => {
  let bug: BusinessUnitGroup | null = null;

  // Swallow getBUG error, we'll rethrow appropriate message for product market if still null
  try {
    bug = getBusinessUnitGroup(key);
  } catch {} /* eslint-disable-line no-empty */

  switch (bug) {
    case BusinessUnitGroup.EFTours:
    case BusinessUnitGroup.StudyAbroad:
      return ProductMarket.EFTours;
    case BusinessUnitGroup.ExploreAmerica:
      return ProductMarket.ExploreAmerica;
    case BusinessUnitGroup.EFToursCanada:
      return ProductMarket.EFToursCanada;
    default:
      throw new Error(`Unrecognized key: "${key}", unable to map to a ProductMarket`);
  }
};

export { getProductMarket, ProductMarket };
